<template>
    <div class="practical-table">实时竞拍开发中</div>
</template>

<script setup></script>
<style lang="scss" scoped></style>
